export function QuickCreateFormSkeleton() {
  return (
    <div className="flex flex-col gap-3.5 pb-2" aria-busy="true" aria-label="A carregar">
      <div className="h-[88px] animate-pulse rounded-2xl bg-muted" />
      <div className="h-[68px] animate-pulse rounded-xl bg-muted" />
      <div className="grid min-w-0 grid-cols-2 gap-3">
        <div className="h-[68px] animate-pulse rounded-xl bg-muted" />
        <div className="h-[68px] animate-pulse rounded-xl bg-muted" />
      </div>
      <div className="h-[68px] animate-pulse rounded-xl bg-muted" />
    </div>
  );
}
